/**
 * Public health check — uses fetch so 503 responses still return the JSON body.
 */
export async function getHealth() {
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const url = `${baseUrl}/health`;

  let response;

  try {
    response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
  } catch (err) {
    // Backend process not reachable (ECONNREFUSED, DNS, CORS network failure, etc.)
    return {
      httpStatus: 0,
      ok: false,
      body: {
        success: false,
        data: {
          status: 'error',
          backend: 'down',
          db: 'unknown',
          message: 'Could not reach the backend',
          error: err?.message || 'Network request failed',
        },
      },
    };
  }

  let body;

  try {
    body = await response.json();
  } catch {
    body = {
      success: false,
      data: {
        status: 'error',
        backend: 'unknown',
        db: 'unknown',
        message: `Health endpoint returned non-JSON (HTTP ${response.status})`,
      },
    };
  }

  return {
    httpStatus: response.status,
    ok: response.ok,
    body,
  };
}
